import { render, staticRenderFns } from "./ThematicPagesManage.vue?vue&type=template&id=45e0be42&"
import script from "./ThematicPagesManage.vue?vue&type=script&lang=js&"
export * from "./ThematicPagesManage.vue?vue&type=script&lang=js&"
import style0 from "./ThematicPagesManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports